<template>
  <v-layout>
    <!-- 로그인 모달 -->
    <v-dialog
      v-model="config.popup.show"
      width="420"
    >
      <v-card>
        <div>
          <img :src="config.popup.url" style="width: 100%; height: auto;"/>
        </div>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click="todayClose()">
            오늘하루안보기
          </v-btn>
          <v-btn color="secondary" flat @click="config.popup.show = false">
            닫기
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
// import Utile from '@/utile/utile'
import { mapState } from 'vuex'

export default {
  name: 'popupBanner',
  data: () => ({
  }),
  mounted () {
  },
  components: {
  },
  computed: {
    ...mapState({
      config: state => state.config
    })
  },
  methods: {
    todayClose () {
      const date = new Date()
      const day = date.getDate()
      const savecode = this.config.popup.code + '-' + day
      localStorage.setItem('popupBanner', savecode)
      // console.log('set:' + localStorage.getItem('popupBanner'))
      this.config.popup.show = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/popupBanner.vue